import { useEffect, useState } from "react";
import { getBookings } from "../services/BookingService";
import Usernav from "../components/Usernav";
import moment from 'moment';
import EmptyData from "../components/EmptyData";

function Booking() {
    const [booking, setBooking] = useState(null);
    const URL = "https://tourbooking-836ce03d218b.herokuapp.com/userBooking";

    useEffect(() => {
        const fetchData = async () => {
            const response = await getBookings(URL);
            setBooking(response);
        };
        fetchData();
    }, []);
  
    return (
        <div className="flex" style={{ backgroundImage:  `url('/images/dashboard.jpg')`, zIndex: -1 }}>
            <div className="bg-black">
                <Usernav/>
                </div>
           
            {!booking ? (
                <p>Loading...</p>
            ) : booking.length === 0 ? (
             
                <EmptyData Message="No bookings yet"/>
            ) : (
                <div className="w-full"  >
                    {booking.map((value, key) => (
                        <div key={key} className=" p-5 border mt-6 border-black bg-gray-300 ">
                            <p className="text-center font-bold mb-10">Booking ID: {value._id}</p>
                            <div className="flex ">
                                <div className="flex-1 w-2 ">
                                    <p style={{ wordWrap: 'break-word' }}>Tour : {value.Tour.Name}</p>
                                </div>
                                <div className="flex-1" >
                                    <p className="text-center">Price: <span className="block sm:inline">$ {value.Tour.Price}</span>
                                 </p>
                                </div>
                                <div className="flex-1  ">
                                    <p className="text-right">Date : {moment(value.date).format('Do-MMMM-YYYY')}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default Booking;


